import * as types from "../actionTypes";
import { PETTY_CASH_PRINT_INFO_MODAL_DATA } from "../actionTypes";

export const getRequest = id => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_REQUEST,
    id
  };
};
export const getRequestSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const getRequestFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_FAILURE,
    error: error
  };
};

export const getItemsRequest = (id, pageNum) => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_REQUEST,
    id,
    pageNum
  };
};
export const getItemsRequestSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_SUCCESS,
    payLoad: data
  };
};
export const getItemsRequestFailure = () => {
  return {
    type: types.PETTY_CASHIER_GET_PETTY_CASH_ITEMS_FAILURE
  };
};

export const getDetail = (id, pageNum) => {
  return {
    type: types.PETTY_CASH_DETAIL_REQUEST,
    id,
    pageNum
  };
};
export const getDetailSuccess = data => {
  return {
    type: types.PETTY_CASH_DETAIL_SUCCESS,
    payLoad: data
  };
};
export const getDetailFailure = (error) => {
  return {
    type: types.PETTY_CASH_DETAIL_FAILURE,
    error:error
  };
};
export const getDetailClear = () => {
  return {
    type: types.PETTY_CASH_DETAIL_CLEAR
  };
};

export const getList = (getAllPages, pageNumber, filters) => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_PETTY_CASH_REQUEST,
    getAllPages,
    pageNumber,
    filters
  };
};
export const getListSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_PETTY_CASH_FAILURE,
    error
  };
};

export const store = data => {
  return {
    type: types.PETTY_CASH_STORE_REQUEST,
    data
  };
};
export const storeSuccess = () => {
  return {
    type: types.PETTY_CASH_STORE_SUCCESS
  };
};
export const storeFailure = () => {
  return {
    type: types.PETTY_CASH_STORE_FAILURE
  };
};

export const update = (id, data) => {
  return {
    type: types.PETTY_CASH_UPDATE_REQUEST,
    data,
    id
  };
};
export const updateSuccess = () => {
  return {
    type: types.PETTY_CASH_UPDATE_SUCCESS
  };
};
export const updateFailure = () => {
  return {
    type: types.PETTY_CASH_UPDATE_FAILURE
  };
};

export const printInfoModalData = data => {
  return {
    type: types.PETTY_CASH_PRINT_INFO_MODAL_DATA,
    data
  };
};
export const printInfoCloseModal = () => {
  return {
    type: types.PETTY_CASH_PRINT_INFO_CLOSE_MODAL
  };
};

export const updateInfo = (id, data) => {
  return {
    type: types.PETTY_CASH_UPDATE_INFO_REQUEST,
    data,
    id
  };
};
export const updateInfoSuccess = data => {
  return {
    type: types.PETTY_CASH_UPDATE_INFO_SUCCESS,
    data
  };
};
export const updateInfoFailure = () => {
  return {
    type: types.PETTY_CASH_UPDATE_INFO_FAILURE
  };
};

export const updateSelectArchive = data => {
  return {
    type: types.PETTY_CASH_SELECT_ARCHIVE_UPDATE,
    data
  };
};
export const saveLastInfo = data => {
  return {
    type: types.PETTY_CASH_SAVE_LAST_INFO,
    data
  };
};

export const changeState = (id, func, data) => {
  return {
    type: types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_REQUEST,
    id,
    func,
    data
  };
};
export const changeStateSuccess = data => {
  return {
    type: types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const changeStateFailure = () => {
  return {
    type: types.PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_FAILURE
  };
};

export const remove = (id, goBack = false) => {
  return {
    type: types.REMOVE_PETTY_CASH_REQUEST,
    id,
    goBack
  };
};

export const removeSuccess = () => {
  return {
    type: types.REMOVE_PETTY_CASH_SUCCESS
  };
};

export const removeFailure = () => {
  return {
    type: types.REMOVE_PETTY_CASH_FAILURE
  };
};

export const detailFilter = data => {
  return {
    type: types.PETTY_CASH_DETAIL_FILTER_REQUEST,
    data
  };
};
export const detailFilterSuccess = data => {
  return {
    type: types.PETTY_CASH_DETAIL_FILTER_SUCCESS,
    payLoad: data
  };
};
export const detailFilterFailure = error => {
  return {
    type: types.PETTY_CASH_DETAIL_FILTER_FAILURE,
    error
  };
};

export const emptyDetailedFilter = () => {
  return {
    type: types.PETTY_CASH_EMPTY_DETAIL_FILTER
  };
};